<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
};
</script>

<style>
:root {
  --primary-color: #236CAD;
  --secondary-color: #73AE5E;
}
</style>
